import Moment from "react-moment";
import { NavLink } from "react-router-dom";
import { PiPackage } from "react-icons/pi";
import { HiOutlineArrowRight } from "react-icons/hi";
import { HiOutlineClock } from "react-icons/hi2";
import { carrierIcons } from "../../assets/icons";

export function SummaryOrderRow({ order }) {
  const logo = carrierIcons[order.carrier?.carrierName];

  return (
    <NavLink
      to={`/dashboard/orders/${order.orderId}`}
      className="
        group block rounded-xl border border-gray-200 bg-white
        transition-all duration-200
        hover:border-[#0052FF]/40
        hover:bg-[#0052FF]/[0.025]
      "
    >
      <div className="px-6 py-5 flex items-center gap-5">
        {/* Icon + Carrier Logo */}
        <div
          className="
    relative flex-shrink-0 w-14 h-14 rounded-xl
    flex items-center justify-center
    bg-[#0052FF]/5 text-[#0052FF]
    transition-all duration-200
    group-hover:bg-[#0052FF]/10
  "
        >
          {/* Package icon (base layer) */}
          <PiPackage className="text-2xl opacity-80" />

          {/* Carrier logo badge */}
          {logo && (
            <div
              className="
        absolute -top-2 -right-2
        flex items-center justify-center
      "
            >
              <div className="w-6 h-6 object-contain">{logo}</div>
            </div>
          )}
        </div>

        {/* Main content */}
        <div className="flex-1 min-w-0">
          {/* Top row */}
          <div className="flex items-center justify-between gap-4">
            <div className="min-w-0">
              <div className="flex items-center gap-2 min-w-0">
                <p
                  className={`text-base font-semibold truncate ${
                    order.orderStatus === "CANCELLED"
                      ? "text-gray-400 line-through"
                      : "text-gray-900"
                  }`}
                >
                  {order.carrier?.carrierName || "Shipment"}
                </p>

                {order.orderStatus === "CANCELLED" && (
                  <span
                    className="
      px-2 py-0.5 rounded-full text-[11px] font-medium
      bg-red-50 text-red-600
    "
                  >
                    Cancelled
                  </span>
                )}
              </div>
              <div className="mt-1 flex flex-wrap items-center gap-2">
                {/* Service badge */}
                <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-600">
                  {order.carrier?.serviceName || "Standard"}
                </span>

                {/* Date */}
                <div className="flex items-center gap-1 text-xs text-gray-500">
                  <HiOutlineClock className="w-3.5 h-3.5" />
                  <Moment format="MMM DD, YYYY">{order.orderDate}</Moment>
                </div>
              </div>
            </div>

            {/* Price */}
            <div className="text-right">
              <p className="text-lg font-semibold text-gray-900 leading-none">
                ${order.charge?.amount}
              </p>
              <p className="text-xs uppercase text-gray-400">
                {order.charge?.currency || "CAD"}
              </p>
            </div>
          </div>
        </div>

        {/* Arrow */}
        <div
          className="
            flex-shrink-0 w-10 h-10 rounded-full
            flex items-center justify-center
            bg-gray-100 text-gray-400
            transition-all duration-200
            group-hover:bg-[#0052FF]/10
            group-hover:text-[#0052FF]
            group-hover:translate-x-0.5
          "
        >
          <HiOutlineArrowRight className="w-5 h-5" />
        </div>
      </div>
    </NavLink>
  );
}
